import React, { Component, Fragment } from 'react';

import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';

import { history } from '../helpers';
import { alertActions } from '../actions/alert.actions';
import { HomeScreen } from '../screens/Home';
import { ScrollToTop } from '../components/ScrollToTop';
import { RequestScreen } from '../screens/Request';
import { RequestFormScreen } from '../screens/Request/form';

import { DelegationScreen } from '../screens/Delegation';
import { DelegationFormScreen } from '../screens/Delegation/form';

import { UserIndexScreen } from '../screens/User/index';
import { UserFormScreen } from '../screens/User/form';
import { LdapIndexScreen } from '../screens/Ldap/index';
import { LdapFormScreen } from '../screens/Ldap/form';
import { SettingsEditScreen } from '../screens/Settings/edit';
import { MainLayout } from '../components/MainLayout/MainLayout';
import { LoginScreen } from '../screens/Login';
import FailedMessage from '../screens/FailedMessage';

import './styles.css';
import { ClockIndexScreen } from '../screens/Clock';
import { WorkJourneyScreen } from '../screens/Report/work-journey';
import { ReportIndexScreen } from '../screens/Report/index';
import { RequestPerManagerReportScreen } from '../screens/Report/request-manager';
import { RequestPerUserReportScreen } from '../screens/Report/request-user';
import { RequestAllReportScreen } from '../screens/Report/request-all';
import { EmailEditScreen } from '../screens/Settings/email';
import { UserLockNotificationsScreen } from '../screens/UserLock/notification';
import { ImportScreen } from '../screens/Settings/import';
import { GlobalSettingsEditScreen } from '../screens/Settings/global';
import { IntegrationLogScreen } from '../screens/Report/integration';
import {GroupIndexScreen} from "../screens/Groups";
import {GroupFormScreen} from "../screens/Groups/form";
import { NotificationConfigIndexScreen } from '../screens/Notification/index';
import { NotificationConfigFormScreen } from '../screens/Notification/form';
import { NotificationScreen } from '../screens/Report/notification';
import { WebhookIndexScreen } from '../screens/Settings/webhook-index';
import { WebhookFormScreen } from '../screens/Settings/webhook-form';
import { LastContactScreen } from '../screens/Report/last-contact';
import { AccessScreen } from '../screens/Report/access';

class App extends Component {
  constructor(props) {
    super(props);

    const { dispatch } = this.props;

    this.state = {
      activeItem: '',
      alert: null
    };

    history.listen(() => {
      dispatch(alertActions.clear());
    });

    this.handleItemClick = this.handleItemClick.bind(this);
  }

  componentDidMount() {

  }

  handleItemClick(e,{name}) {

    this.setState({
      activeItem: name
    });

    history.push(`/${name}`)
  }

  handleLogoutClick(){
    localStorage.clear();
    history.push('/login')
  }

  render() {
    const { alert } = this.props;
    const { activeItem } = this.state;

    if (alert.message) {
      toast({
        type: alert.type,
        icon: 'info',
        description: alert.message ,
        time: 2000,
        onClose: () => {
          const { dispatch } = this.props;
          dispatch(alertActions.clear());
        }
      });
    }

    return (
      <Fragment>
          <ScrollToTop />
          <SemanticToastContainer position="bottom-right" />
          <Switch>
              <Route exact path="/login" component={LoginScreen} />
              <Route exact path="/login/___local" component={LoginScreen} />
              <Route exact path="/404" component={FailedMessage} />
              <Route exact path="/settings" component={SettingsEditScreen} />
            <MainLayout>            
              <div className="wrapper">
                <Route exact path="/" authorize={["home"]} component={HomeScreen} />
                <Route exact path="/requests" authorize={["request.fetch"]} component={RequestScreen} />
                <Route exact path="/request/create" authorize={["request.create"]} component={RequestFormScreen} />
                <Route exact path="/request/update/:id" authorize={["request.update"]} component={RequestFormScreen} />
                <Route exact path="/delegations" authorize={["delegation.fetch"]} component={DelegationScreen} />
                <Route exact path="/delegation/create" authorize={["delegation.create"]} component={DelegationFormScreen} />
                <Route exact path="/users" authorize={["user.fetch"]} component={UserIndexScreen} />
                <Route exact path="/user/create" authorize={["user.create"]} component={UserFormScreen} />
                <Route exact path="/user/update/:id" authorize={["user.update"]} component={UserFormScreen} />
                <Route exact path="/ldap" authorize={["ldap.fetch"]} component={LdapIndexScreen} />
                <Route exact path="/ldap/create" authorize={["ldap.create"]} component={LdapFormScreen} />
                <Route exact path="/ldap/update/:id" authorize={["ldap.update"]} component={LdapFormScreen} />
                <Route exact path="/clock" authorize={["clock.fetch"]} component={ClockIndexScreen} />
                <Route exact path="/mail" authorize={["mail.edit"]} component={EmailEditScreen} />
                <Route exact path="/userlock/notifications" authorize={["request.fetch"]} component={UserLockNotificationsScreen} />
                <Route exact path="/importar-usuarios" authorize={["mail.edit"]} component={ImportScreen} />
                <Route exact path="/global-settings" authorize={["mail.edit"]} component={GlobalSettingsEditScreen} />
                <Route exact path="/settings/webhooks" authorize={["mail.edit"]} component={WebhookIndexScreen} />
                <Route exact path="/settings/webhooks/create" authorize={["mail.edit"]} component={WebhookFormScreen} />
                <Route exact path="/settings/webhooks/update/:id" authorize={["mail.edit"]} component={WebhookFormScreen} />
                <Route exact path="/report/work-journey" authorize={["user.fetch"]} component={WorkJourneyScreen} />
                <Route exact path="/report/last-contact" authorize={["user.fetch"]} component={LastContactScreen} />
                <Route exact path="/report/auth" authorize={["user.fetch"]} component={AccessScreen} />
                <Route exact path="/report/integration-log" authorize={["user.fetch"]} component={IntegrationLogScreen} />
                <Route exact path="/report/index" authorize={["user.fetch"]} component={ReportIndexScreen} />
                <Route exact path="/report/request-manager" authorize={["user.fetch"]} component={RequestPerManagerReportScreen} />
                <Route exact path="/report/request-user" authorize={["user.fetch"]} component={RequestPerUserReportScreen} />
                <Route exact path="/report/request-all" authorize={["user.fetch"]} component={RequestAllReportScreen} />
                <Route exact path="/groups" authorize={["user.fetch"]} component={GroupIndexScreen} />
                <Route exact path="/group/create" authorize={["user.create"]} component={GroupFormScreen} />
                <Route exact path="/group/update/:id" authorize={["user.update"]} component={GroupFormScreen} />
                <Route exact path="/notification/config" authorize={["user.update"]} component={NotificationConfigIndexScreen} />
                <Route exact path="/notification/config/update/:id" authorize={["user.update"]} component={NotificationConfigFormScreen} />
                <Route exact path="/notification/config/create" authorize={["user.update"]} component={NotificationConfigFormScreen} />
                <Route exact path="/notification/log" authorize={["user.update"]} component={NotificationScreen} />              
              </div>
          </MainLayout>
        </Switch>
      </Fragment>        
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert
  };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };
